import { z } from 'zod';

import { CmsUrl } from '../models';
import { BasePType } from './base';

export const PrimaryFooterLinkTarget = z.object({
  tid: z.number(),
  value: z.enum(['_blank', '_self']),
  name: z.string(),
});

export const PrimaryFooterLink = BasePType.extend({
  type: z.enum(['primaryFooterLink']),
  aTarget: PrimaryFooterLinkTarget.nullable(),
  url: CmsUrl,
});

export type PrimaryFooterLink = z.infer<typeof PrimaryFooterLink>;
